import { getItem, setItem } from 'api/utils/storageManager'
import { useEffect, useState } from 'react'
import { ViewMode } from 'types/customParams'
import { CustomColorsRef, IconSizes } from 'types/general'

import IconRender from './common/IconRender'

export default function ViewToggle() {
  const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.Grid)

  useEffect(() => {
    const storedMode = getItem(ViewMode.ViewModeKey) as ViewMode

    if (storedMode !== ViewMode.List && storedMode !== ViewMode.Grid) {
      setViewMode(ViewMode.Grid)
    } else {
      setViewMode(storedMode)
    }
  }, [])

  const handleToggle = (mode: ViewMode.Grid | ViewMode.List) => {
    setViewMode(mode)
    setItem(ViewMode.ViewModeKey, mode)
    window.dispatchEvent(new Event('viewModeChanged'))
  }

  return (
    <div className="relative flex h-9 w-[74px] items-center rounded-lg border border-gray-300 bg-gray-100 p-0.5 shadow-sm">
      <div
        className="absolute left-0.5 top-0.5 h-[calc(100%-4px)] w-[calc(50%-2px)] rounded-md border border-imovPrimary bg-white shadow-sm transition-transform duration-300 ease-in-out"
        style={{
          transform:
            viewMode === ViewMode.List ? 'translateX(100%)' : 'translateX(0%)',
        }}
      />

      <button
        type="button"
        onClick={() => handleToggle(ViewMode.Grid)}
        className="relative z-10 flex h-full w-1/2 items-center justify-center"
        aria-label="Grid View"
      >
        <IconRender
          icon="regular-grid"
          size={IconSizes.MD}
          hoverColor={
            viewMode === ViewMode.Grid ? '' : CustomColorsRef.PrimaryLight
          }
          color={
            viewMode === ViewMode.Grid
              ? CustomColorsRef.Primary
              : CustomColorsRef.Gray
          }
        />
      </button>

      <button
        type="button"
        onClick={() => handleToggle(ViewMode.List)}
        className="relative z-10 flex h-full w-1/2 items-center justify-center"
        aria-label="List View"
      >
        <IconRender
          icon="regular-list"
          size={IconSizes.MD}
          hoverColor={
            viewMode === ViewMode.List ? '' : CustomColorsRef.PrimaryLight
          }
          color={
            viewMode === ViewMode.List
              ? CustomColorsRef.Primary
              : CustomColorsRef.Gray
          }
        />
      </button>
    </div>
  )
}
